import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Typography,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import ApiService from "../../Api/ApiController";
import Swal from "sweetalert2";

const CreateStocksCategory = () => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    value: "",
    change_value: "",
    change_percent: "",
    direction: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" }); // clear error on change
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Category name is required";
    if (!formData.value.trim()) newErrors.value = "Category value is required";
    if (!formData.change_value.trim())
      newErrors.change_value = "Category change value is required";
    if (!formData.change_percent.trim())
      newErrors.change_percent = "Category change percent is required";
    if (!formData.direction.trim())
      newErrors.direction = "Direction is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    ApiService.createStockCategory(formData)
      .then((response) => {
        if (response.data.status === true) {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          setFormData({
            name: "",
            description: "",
            value: "",
            change_value: "",
            change_percent: "",
            direction: "",
          });
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            title: response.data.message,
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        bgcolor: "#f5f6fa",
        p: 2,
      }}
    >
      <Card sx={{ maxWidth: 600, width: "100%", boxShadow: 3, borderRadius: 3 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Create Stock Category
          </Typography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              {/* Index Name */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Index Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  error={!!errors.name}
                  helperText={errors.name}
                />
              </Grid>

              {/* Index Value & Change Value Side by Side */}
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Index Value"
                  name="value"
                  value={formData.value}
                  onChange={handleChange}
                  error={!!errors.value}
                  helperText={errors.value}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Change Value"
                  name="change_value"
                  value={formData.change_value}
                  onChange={handleChange}
                  error={!!errors.change_value}
                  helperText={errors.change_value}
                />
              </Grid>

              {/* Change Percent & Direction Side by Side */}
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Change Percent"
                  name="change_percent"
                  value={formData.change_percent}
                  onChange={handleChange}
                  error={!!errors.change_percent}
                  helperText={errors.change_percent}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth error={!!errors.direction}>
                  <InputLabel id="direction-label">Direction</InputLabel>
                  <Select
                    labelId="direction-label"
                    name="direction"
                    value={formData.direction}
                    onChange={handleChange}
                    label="Direction" // ✅ fixes label cutting
                  >
                    <MenuItem value="up">Up</MenuItem>
                    <MenuItem value="down">Down</MenuItem>
                  </Select>
                  {errors.direction && (
                    <Typography variant="caption" color="error">
                      {errors.direction}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              {/* Description */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Description"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  multiline
                  rows={3}
                />
              </Grid>

              {/* Submit Button */}
              <Grid item xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ borderRadius: 2 }}
                >
                  Save Category
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CreateStocksCategory;
